'use client';

import { COLORS } from '@/constants';
import { Button } from '@mui/material';
import styled from 'styled-components';

interface StyledButtonProps {
  $theme?: string;
}

export const StyledButton = styled(Button)<StyledButtonProps>`
  && {
    box-shadow: none;
    height: 40px;
    padding: 10px;
    font-size: 14px;
    font-weight: 500;
    text-transform: none;
    
    ${({ $theme }) => {
      switch ($theme) {
        case 'contained-light':
          return `
            background-color: ${COLORS['neutral/200']} !important;
            color: ${COLORS['neutral/700']} !important;
            border: none;
            & > span > svg > path {
              fill: ${COLORS['neutral/700']};
            }
            &:hover {
              background-color: ${COLORS['neutral/300']} !important;
              box-shadow: none;
            }
          `;
        
        case 'contained-accent':
          return `
            background-color: ${COLORS['secondary/500']} !important;
            color: ${COLORS.white} !important;
            border: none;
            & > span > svg > path {
              fill: ${COLORS.white};
            }
            &:hover {
              background-color: ${COLORS['secondary/700']} !important;
              box-shadow: none;
            }
          `;
        
        case 'text-light':
          return `
            background-color: transparent !important;
            color: ${COLORS['gray-dark']} !important;
            border: none;
            & > span > svg > path {
              fill: ${COLORS['gray-dark']};
            }
            &:hover {
              background-color: ${COLORS['neutral/100']} !important;
              box-shadow: none;
            }
          `;
        
        case 'text-primary':
          return `
            background-color: transparent !important;
            color: ${COLORS['primary/600']} !important;
            border: none;
            & > span > svg > path {
              fill: ${COLORS['primary/600']};
            }
            &:hover {
              background-color: ${COLORS['neutral/100']} !important;
              box-shadow: none;
            }
          `;
        
        case 'outline-primary-primary':
          return `
            background-color: transparent !important;
            border: 2px solid ${COLORS['primary/700']} !important;
            color: ${COLORS['primary/700']} !important;
            & > span > svg > path {
              fill: ${COLORS['primary/700']};
            }
            &:hover {
              background-color: ${COLORS['primary/700']} !important;
              color: ${COLORS.white} !important;
              box-shadow: none;
              & > span > svg > path {
                fill: ${COLORS.white};
              }
            }
          `;
        
        case 'outline-primary-light':
        default:
          return `
            background-color: transparent !important;
            border: 2px solid ${COLORS['primary/500']} !important;
            color: ${COLORS['primary/600']} !important;
            & > span > svg > path {
              fill: ${COLORS['secondary/500']};
            }
            &:hover {
              background-color: ${COLORS['primary/500']} !important;
              color: ${COLORS.white} !important;
              box-shadow: none;
              & > span > svg > path {
                fill: ${COLORS.white};
              }
            }
          `;
      }
    }}
    
    &:disabled {
      background-color: ${COLORS['neutral/200']} !important;
      color: ${COLORS['neutral/500']} !important;
      border-color: ${COLORS['neutral/300']} !important;
      opacity: 0.6;
    }
  }
`;
